import { useCallback, useState } from 'react';
import { get, set } from '../../../../../store/safeLocalStorage';
import { useUserTokenDecoded } from '../../../../../redux/slices/appInfo/hooks';

const keyFor = (userId: number): string => `m24ReleasesQuietOpen:${userId}`;

/**
 * The open or closed state of the Quiet group (design a3: kept per user in local storage). A
 * browser with no storage keeps it for the visit only; `safeLocalStorage` never throws.
 */
export function useQuietOpen(): { isOpen: boolean; toggle: () => void } {
  const userId = useUserTokenDecoded()?.id ?? null;
  const [isOpen, setIsOpen] = useState<boolean>(() => userId !== null && get<unknown>(keyFor(userId)) === true);

  const toggle = useCallback(() => {
    setIsOpen((open) => {
      const next = !open;
      if (userId !== null) {
        set(keyFor(userId), next);
      }
      return next;
    });
  }, [userId]);

  return { isOpen, toggle };
}
